import { FreeCamera, HemisphericLight, MeshBuilder, Vector3, WebXRDefaultExperience } from 'babylonjs';
import { XRModuleSession, XRModuleSessionOptions } from './app.webxr.modules';
import AppContent from './app.content';

export default class AppWebXRSimple extends AppContent {

  protected xr?: WebXRDefaultExperience;
  protected xrSession?: XRModuleSession;
  protected contentPosition: Vector3 = new Vector3(0, 0, -1.5);

  constructor(renderCanvas: HTMLCanvasElement) {
    super(renderCanvas);
  }

  protected override initialize() {
    super.initialize();
    this.initCustom();    
    this.initXR();
  }

  protected override initEngine(): void {
    super.initEngine();
  }

  protected override initScene(): void {
    super.initScene();
    this.scene!.autoClear = true;
  }

  protected override initCamera(): void {
    const camera = new FreeCamera("camera", new Vector3(0, 0, 0), this.scene);
    camera.setTarget(this.contentPosition);
    camera.attachControl(this.renderCanvas, true);
    this.camera = camera;
  }

  protected initCustom(): void {
    const light = new HemisphericLight("light", new Vector3(0, 1, 0), this.scene);
    light.intensity = 0.7;
  
    const sphere = MeshBuilder.CreateSphere("sphere", {diameter: 0.2, segments: 32}, this.scene);
    sphere.position.copyFrom(this.contentPosition);
  }

  protected initXROptions(): XRModuleSessionOptions {
    const options = new XRModuleSessionOptions();
    options.disableDefaultUI = false;
    options.domOverlayElementName = '#domOverlay';
    return options;
  }

  protected async initXR() {
    try {
      const options = this.initXROptions();
      this.xrSession = new XRModuleSession();
      this.xr = await this.xrSession.init(this.scene!, options);
      if( !this.xr ) {
        throw new Error('app.webxr.simple.initXR: failed');
      }
      this.mediaRecorder?.initWeb(this.scene!, this.xr);
    } catch (error) {
      console.error(error);
    }
  }

  public isXRRunning(): boolean {
    return !!this.xrSession?.isXRRunning;
  }

  public override render(): void {
    // override.
  }
}